export default "__VITE_PUBLIC_ASSET__5e34b812__"